import { render, staticRenderFns } from "./ModalWindow.vue?vue&type=template&id=7b12a0b2&scoped=true&"
import script from "./ModalWindow.vue?vue&type=script&lang=ts&"
export * from "./ModalWindow.vue?vue&type=script&lang=ts&"
import style0 from "./ModalWindow.vue?vue&type=style&index=0&id=7b12a0b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b12a0b2",
  null
  
)

export default component.exports